import { NgModule, ErrorHandler, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TripViewModule } from './trip-view/trip-view.module';
import { TripViewCabModule } from './trip-view-cab/trip-view-cab.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { DutyViewModule } from './duty-view/duty-view.module'
import { TripReplayModule } from './trip-replay/trip-replay.module';
import { TripReplayCabModule } from './trip-replay-cab/trip-replay-cab.module';
import { ToastModule } from 'mis-crystal-design-system/toast';
import { AuthInterceptor } from './auth.interceptor';
import player from 'lottie-web';
import { LottieModule } from 'ngx-lottie';
import { PageNotFound } from './page-not-found/page-not-found';
import * as Sentry from "@sentry/angular";
import { Router } from '@angular/router';
import { RouteReplayModule } from './route-replay/route-replay.module';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    AppComponent,
    PageNotFound
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TripViewModule,
    HttpClientModule,
    TripViewCabModule,
    DutyViewModule,
    TripReplayModule,
    TripViewCabModule,
    TripReplayCabModule,
    ToastModule,
    RouteReplayModule,
    LottieModule.forRoot({ player: playerFactory }),
  ],
  providers: [
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
